import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Attachment, AttachmentType, ChartAttachment, ImageAttachment } from '../../pages/Chat/Chat/types';
import Charts from '../Charts/Charts';
import Image from '../Image/Image';

const ResponseAttachment: FC<Attachment> = (props) => {
    const { t } = useTranslation();
    const attachmentList: Record<AttachmentType, JSX.Element> = {
        image: <Image {...(props as ImageAttachment)} />,
        chart: <Charts attachments={props as ChartAttachment} />,
    };
    return attachmentList[props.type] || <div>{t('errors.attachmentNotFound')}</div>;
};

export default ResponseAttachment;
